const seats = [
  {x: 100, y: 100, status: 1, category: 3},
  {x: 120, y: 100, status: 1, category: 3},
  {x: 140, y: 100, status: 1, category: 3},
  {x: 160, y: 100, status: 1, category: 3},
  {x: 180, y: 100, status: 1, category: 3},
  {x: 200, y: 100, status: 1, category: 3},
  {x: 220, y: 100, status: 1, category: 3},
  {x: 240, y: 100, status: 1, category: 3},
  {x: 260, y: 100, status: 1, category: 3},
  {x: 280, y: 100, status: 1, category: 3},

  {x: 100, y: 120, status: 1, category: 3},
  {x: 120, y: 120, status: 1, category: 3},
  {x: 140, y: 120, status: 1, category: 3},
  {x: 160, y: 120, status: 1, category: 3},
  {x: 180, y: 120, status: 0, category: 3},
  {x: 200, y: 120, status: 0, category: 3},
  {x: 220, y: 120, status: 0, category: 3},
  {x: 240, y: 120, status: 0, category: 3},
  {x: 260, y: 120, status: 1, category: 3},
  {x: 280, y: 120, status: 1, category: 3},

  {x: 100, y: 140, status: 1, category: 2},
  {x: 120, y: 140, status: 1, category: 2},
  {x: 140, y: 140, status: 1, category: 2},
  {x: 160, y: 140, status: 1, category: 2},
  {x: 180, y: 140, status: 1, category: 2},
  {x: 200, y: 140, status: 1, category: 2},
  {x: 220, y: 140, status: 1, category: 2},
  {x: 240, y: 140, status: 1, category: 2},
  {x: 260, y: 140, status: 1, category: 2},
  {x: 280, y: 140, status: 1, category: 2},

  {x: 100, y: 160, status: 1, category: 2},
  {x: 120, y: 160, status: 1, category: 2},
  {x: 140, y: 160, status: 1, category: 2},
  {x: 160, y: 160, status: 0, category: 2},
  {x: 180, y: 160, status: 0, category: 2},
  {x: 200, y: 160, status: 1, category: 2},
  {x: 220, y: 160, status: 1, category: 2},
  {x: 240, y: 160, status: 1, category: 2},
  {x: 260, y: 160, status: 1, category: 2},
  {x: 280, y: 160, status: 1, category: 2},

  {x: 100, y: 180, status: 1, category: 1},
  {x: 120, y: 180, status: 1, category: 1},
  {x: 140, y: 180, status: 0, category: 1},
  {x: 160, y: 180, status: 1, category: 1},
  {x: 180, y: 180, status: 1, category: 1},
  {x: 200, y: 180, status: 1, category: 1},
  {x: 220, y: 180, status: 1, category: 1},
  {x: 240, y: 180, status: 1, category: 1},
  {x: 260, y: 180, status: 1, category: 1},
  {x: 280, y: 180, status: 1, category: 1},

  {x: 100, y: 200, status: 1, category: 1},
  {x: 120, y: 200, status: 1, category: 1},
  {x: 140, y: 200, status: 1, category: 1},
  {x: 160, y: 200, status: 0, category: 1},
  {x: 180, y: 200, status: 0, category: 1},
  {x: 200, y: 200, status: 0, category: 1},
  {x: 220, y: 200, status: 1, category: 1},
  {x: 240, y: 200, status: 1, category: 1},
  {x: 260, y: 200, status: 0, category: 1},
  {x: 280, y: 200, status: 0, category: 1},
]

export default seats